(function () {
  const LOG = '[ATJ Gallery]';
  const DEBUG = false;
  const MAIN_WIDTHS = [480, 990, 1440, 1600, 1946];
  const MAIN_SIZES = '(min-width: 990px) min(54vw, 720px), 100vw';
  const THUMB_WIDTH = 240;

  function log(...args) {
    if (DEBUG) console.log(LOG, ...args);
  }

  function getGallery() {
    return document.querySelector('.custom-product-gallery');
  }

  function slides(gallery) {
    return Array.from(gallery.querySelectorAll('.custom-gallery__main-image'));
  }

  function getSlider(gallery) {
    if (!gallery.__atjSlider) gallery.__atjSlider = { index: 0 };
    return gallery.__atjSlider;
  }

  function goTo(gallery, nextIndex) {
    const images = slides(gallery);
    if (!images.length) return;

    const slider = getSlider(gallery);
    slider.index = Math.max(0, Math.min(nextIndex, images.length - 1));

    const viewport = gallery.querySelector('.custom-gallery__main-frame') || gallery.querySelector('.custom-gallery__main');
    const track = gallery.querySelector('[data-custom-gallery-main-track]');
    if (track && viewport) {
      track.style.transform = `translateX(-${slider.index * viewport.clientWidth}px)`;
    }

    images.forEach((image, index) => image.classList.toggle('is-active', index === slider.index));
    gallery.querySelectorAll('.custom-gallery__thumbnail').forEach((thumb, index) => {
      thumb.classList.toggle('is-active-thumb', index === slider.index);
    });

    if (typeof gallery.__updateThumbNav === 'function') gallery.__updateThumbNav();
    updateCounter(gallery);
  }

  function bindThumbNav(gallery) {
    const updateNav = () => {
      const strip = gallery.querySelector('[data-custom-gallery-thumbnails]');
      const prevButton = gallery.querySelector('[data-custom-gallery-thumb-prev]');
      const nextButton = gallery.querySelector('[data-custom-gallery-thumb-next]');
      if (!strip || !prevButton || !nextButton) return;
      const maxScroll = Math.max(0, strip.scrollWidth - strip.clientWidth);
      const atStart = strip.scrollLeft <= 1;
      const atEnd = strip.scrollLeft >= maxScroll - 1;
      const hasOverflow = maxScroll > 1;
      prevButton.disabled = !hasOverflow || atStart;
      nextButton.disabled = !hasOverflow || atEnd;
      prevButton.classList.toggle('is-disabled', prevButton.disabled);
      nextButton.classList.toggle('is-disabled', nextButton.disabled);
    };

    gallery.__updateThumbNav = updateNav;

    const strip = gallery.querySelector('[data-custom-gallery-thumbnails]');
    if (strip && strip.dataset.scrollBound !== 'true') {
      strip.dataset.scrollBound = 'true';
      strip.addEventListener('scroll', updateNav, { passive: true });
    }

    if (gallery.dataset.thumbNavHandlersAttached === 'true') {
      updateNav();
      return;
    }
    gallery.dataset.thumbNavHandlersAttached = 'true';

    gallery.addEventListener('click', (event) => {
      const prev = event.target.closest('[data-custom-gallery-thumb-prev]');
      const next = event.target.closest('[data-custom-gallery-thumb-next]');
      if (!prev && !next) return;
      const currentStrip = gallery.querySelector('[data-custom-gallery-thumbnails]');
      if (!currentStrip) return;
      const thumb = currentStrip.querySelector('.custom-gallery__thumbnail');
      const gap = Number.parseFloat(getComputedStyle(currentStrip).gap) || 8;
      const step = (thumb?.offsetWidth || 76) + gap;
      if (prev && !prev.disabled) currentStrip.scrollBy({ left: -step, behavior: 'smooth' });
      if (next && !next.disabled) currentStrip.scrollBy({ left: step, behavior: 'smooth' });
    });

    window.addEventListener('resize', updateNav);
    updateNav();
  }

  function bindSwipe(gallery) {
    gallery.addEventListener(
      'touchstart',
      (event) => {
        const frame = event.target.closest('.custom-gallery__main-frame, .custom-gallery__main');
        if (!frame || !gallery.contains(frame)) return;
        gallery.__swipeX = event.touches[0].clientX;
      },
      { passive: true }
    );

    gallery.addEventListener(
      'touchend',
      (event) => {
        if (gallery.__swipeX == null) return;
        const endX = event.changedTouches[0].clientX;
        const delta = endX - gallery.__swipeX;
        gallery.__swipeX = null;
        if (Math.abs(delta) < 40) return;
        goTo(gallery, getSlider(gallery).index + (delta < 0 ? 1 : -1));
      },
      { passive: true }
    );
  }

  function bindThumbnails(gallery) {
    if (gallery.dataset.thumbnailHandlersAttached === 'true') return;
    gallery.dataset.thumbnailHandlersAttached = 'true';

    gallery.addEventListener('click', (event) => {
      const thumb = event.target.closest('.custom-gallery__thumbnail');
      if (!thumb || !gallery.contains(thumb)) return;
      const thumbs = Array.from(gallery.querySelectorAll('.custom-gallery__thumbnail'));
      goTo(gallery, thumbs.indexOf(thumb));
    });
  }

  function isStaticGallery() {
    const root = document.querySelector('[data-custom-color-swatches]');
    return root?.dataset?.staticGallery === 'true';
  }

  function updateSwatchUI(colorValue, optionPosition, optionName) {
    const root = document.querySelector('[data-custom-color-swatches]');
    if (!root || !colorValue) return;

    const groups = root.querySelectorAll('[data-color-option]');
    const targetGroup =
      (optionPosition &&
        root.querySelector(`[data-color-option][data-color-option-position="${optionPosition}"]`)) ||
      (optionName &&
        Array.from(groups).find((g) => (g.dataset.colorOptionName || '') === optionName)) ||
      (groups.length <= 1 ? groups[0] || root : null);

    if (!targetGroup) return;

    const label = targetGroup.querySelector('[data-selected-color-value]');
    if (label) label.textContent = colorValue;

    targetGroup.querySelectorAll('[data-color-swatch]').forEach((button) => {
      const isSelected = button.dataset.optionValue === colorValue;
      button.classList.toggle('is-selected', isSelected);
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }

  function hideNativeColorPicker() {
    const customRoot = document.querySelector('[data-custom-color-swatches]');
    if (!customRoot || !customRoot.querySelector('[data-color-option], [data-color-swatch]')) return;

    document
      .querySelectorAll(
        'variant-selects fieldset.js.product-form__input, variant-selects .product-form__input--dropdown, variant-selects .product-form__input--swatch'
      )
      .forEach((field) => {
        const label = field.querySelector('legend.form__label, label.form__label');
        const optionName =
          field.querySelector('input[type="radio"]')?.dataset?.optionName ||
          field.querySelector('select')?.getAttribute('name') ||
          '';
        const text = `${label?.textContent || ''} ${optionName}`;
        if (/color|krāsa|krasa|colour|reform|pakl|riņķ|rink|ring/i.test(text)) {
          field.classList.add('custom-product-info__native-color-picker--hidden');
        }
      });
  }

  function syncNativeRadio(colorValue, optionPosition, optionName) {
    if (!colorValue) return;
    const scope = document.querySelector('variant-selects') || document.querySelector('product-info');
    if (!scope) return;
    const radios = Array.from(scope.querySelectorAll('input[type="radio"]'));
    let match = null;

    if (optionName) {
      match = radios.find(
        (radio) => radio.value === colorValue && (radio.dataset.optionName || '') === optionName
      );
    }

    if (!match && optionPosition) {
      match = radios.find((radio) => {
        if (radio.value !== colorValue) return false;
        const name = radio.name || '';
        return (
          name.endsWith(`-${optionPosition}`) ||
          name === `option${optionPosition}` ||
          radio.closest('fieldset')?.querySelector(`[data-option-position="${optionPosition}"]`)
        );
      });
    }

    if (!match) {
      // Single-option products (reformer): prefer colour-named radios
      const colourMatches = radios.filter((radio) => {
        if (radio.value !== colorValue) return false;
        const optionLabel = radio.dataset.optionName || '';
        return /color|colour|krāsa|krasa/i.test(optionLabel) || /^color-/i.test(radio.name || '');
      });
      match = colourMatches[0] || radios.find((radio) => radio.value === colorValue) || null;
    }

    if (!match || match.disabled || match.checked) return;
    match.checked = true;
    match.dispatchEvent(new Event('input', { bubbles: true }));
    match.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function parseGalleryData(gallery) {
    if (gallery.__atjGalleryData) return gallery.__atjGalleryData;
    const script = gallery.querySelector('[data-atj-variant-gallery-data]');
    if (!script) return null;
    try {
      gallery.__atjGalleryData = JSON.parse(script.textContent);
    } catch (error) {
      console.warn(LOG, 'Gallery JSON parse failed', error);
      gallery.__atjGalleryData = null;
    }
    return gallery.__atjGalleryData;
  }

  function isUsableUrl(url) {
    if (!url || typeof url !== 'string') return false;
    const value = url.trim().toLowerCase();
    if (!value) return false;
    if (value.includes('no-image') || value.includes('no_image')) return false;
    return true;
  }

  function normalizeUrlKey(url) {
    if (!url) return '';
    try {
      const parsed = new URL(url.startsWith('//') ? `https:${url}` : url);
      return parsed.pathname.replace(/\/+$/, '').toLowerCase();
    } catch (error) {
      return String(url).split('?')[0].toLowerCase();
    }
  }

  function sharedGalleryUrls(data) {
    const fromShared = (data?.sharedGallery || [])
      .map((item) => (typeof item === 'string' ? item : item?.src))
      .filter(isUsableUrl);
    if (fromShared.length) return fromShared;

    return (data?.productImages || [])
      .filter((image) => image?.shared === true)
      .map((image) => image.src)
      .filter(isUsableUrl);
  }

  function mergeUniqueUrls(...lists) {
    const seen = new Set();
    const merged = [];
    lists.flat().forEach((url) => {
      if (!isUsableUrl(url)) return;
      const key = normalizeUrlKey(url);
      if (!key || seen.has(key)) return;
      seen.add(key);
      merged.push(url);
    });
    return merged;
  }

  function urlsForVariant(data, variantId, colorValue) {
    const shared = sharedGalleryUrls(data);
    const fallback = (data?.fallback?.gallery || []).filter(isUsableUrl);
    const variants = data?.variants || [];
    const variant = variants.find((item) => String(item.id) === String(variantId));
    const fromVariant = (variant?.gallery || []).filter(isUsableUrl);
    if (fromVariant.length) return mergeUniqueUrls(shared, fromVariant);

    if (colorValue) {
      const slug = String(colorValue).toLowerCase().replace(/\s+/g, '');
      const colorSlug = slug === 'grey' ? 'gray' : slug;
      const fromColor = (data?.productImages || [])
        .filter((image) => {
          if (image?.shared) return false;
          const src = String(image?.src || '').toLowerCase();
          const tag = String(image?.colorTag || '').toLowerCase();
          const alt = String(image?.alt || '').toLowerCase();
          return tag === colorSlug || src.includes(colorSlug) || alt.includes(colorSlug);
        })
        .map((image) => image.src)
        .filter(isUsableUrl);
      if (fromColor.length) return mergeUniqueUrls(shared, fromColor);
    }

    return mergeUniqueUrls(shared, fallback);
  }

  function attr(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  function withWidth(url, width) {
    if (!url) return '';
    if (url.includes('width=')) {
      try {
        const parsed = new URL(url.startsWith('//') ? `https:${url}` : url);
        parsed.searchParams.set('width', String(width));
        return parsed.toString();
      } catch (error) {
        return url;
      }
    }
    return url.includes('?') ? `${url}&width=${width}` : `${url}?width=${width}`;
  }

  function buildMainSrcset(url) {
    return MAIN_WIDTHS.map((width) => `${attr(withWidth(url, width))} ${width}w`).join(', ');
  }

  function galleryAltBase() {
    const heading = document.querySelector('.custom-product-info__heading, h1');
    return attr(heading?.textContent?.trim() || ((document.documentElement.lang || '').toLowerCase().indexOf('en') === 0 ? 'Product' : 'Produkts'));
  }

  function buildAlt(index, colorValue, explicitAlt) {
    if (explicitAlt && String(explicitAlt).trim()) return attr(String(explicitAlt).trim());
    const base = galleryAltBase();
    const isEn = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
    const colorPart = colorValue ? ` — ${isEn ? 'colour' : 'krāsa'} ${attr(colorValue)}` : '';
    return `${base}${colorPart}, ${isEn ? 'image' : 'attēls'} ${index + 1}`;
  }

  function altLookup(data) {
    const map = new Map();
    (data?.sharedGallery || []).forEach((item) => {
      if (!item?.src) return;
      map.set(normalizeUrlKey(item.src), item.alt || '');
    });
    (data?.productImages || []).forEach((item) => {
      if (!item?.src) return;
      map.set(normalizeUrlKey(item.src), item.alt || '');
    });
    return map;
  }

  function setGalleryLoading(gallery, loading) {
    gallery.classList.toggle('custom-product-gallery--loading', loading);
    gallery.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  function updateCounter(gallery) {
    const counter = gallery.querySelector('[data-custom-gallery-counter]');
    if (!counter) return;
    const total = slides(gallery).length;
    const index = getSlider(gallery).index + 1;
    counter.textContent = total ? `${index} / ${total}` : '';
    counter.hidden = total < 2;
  }

  function rebuildGallery(gallery, urls, variantId, colorValue) {
    const track = gallery.querySelector('[data-custom-gallery-main-track]');
    const thumbs = gallery.querySelector('[data-custom-gallery-thumbnails]');
    if (!track || !thumbs || !urls.length) {
      console.warn(LOG, 'Cannot rebuild gallery', { urls: urls?.length, variantId });
      return;
    }

    setGalleryLoading(gallery, true);
    const alts = altLookup(parseGalleryData(gallery));

    track.innerHTML = urls
      .map((url, index) => {
        const src = attr(withWidth(url, 1600));
        const active = index === 0 ? ' is-active' : '';
        const loading = index === 0 ? 'eager' : 'lazy';
        const fetchPriority = index === 0 ? ' fetchpriority="high"' : '';
        const decoding = index === 0 ? 'sync' : 'async';
        const srcset = buildMainSrcset(url);
        const altText = buildAlt(index, colorValue, alts.get(normalizeUrlKey(url)));
        return `<img class="custom-gallery__main-image is-visible${active}" src="${src}" srcset="${srcset}" sizes="${MAIN_SIZES}" alt="${altText}" width="1600" height="1600" decoding="${decoding}" loading="${loading}"${fetchPriority} draggable="false" data-media-id="variant-${attr(variantId)}-${index + 1}">`;
      })
      .join('');

    thumbs.innerHTML = urls
      .map((url, index) => {
        const src = attr(withWidth(url, THUMB_WIDTH));
        const active = index === 0 ? ' is-active-thumb' : '';
        const altText = buildAlt(index, colorValue, alts.get(normalizeUrlKey(url)));
        return `<img class="custom-gallery__thumbnail is-visible${active}" src="${src}" alt="${altText}" width="200" height="200" loading="lazy" decoding="async" draggable="false" role="button" tabindex="0" data-custom-gallery-thumb data-media-id="variant-${attr(variantId)}-${index + 1}">`;
      })
      .join('');

    gallery.dataset.activeVariantId = String(variantId);
    getSlider(gallery).index = 0;
    bindThumbNav(gallery);
    requestAnimationFrame(() => {
      goTo(gallery, 0);
      updateCounter(gallery);
      setGalleryLoading(gallery, false);
    });
    log('Gallery rebuilt', { variantId, images: urls.length });
  }

  function loadGalleryForVariant(gallery, variantId, colorValue) {
    if (!variantId) {
      console.warn(LOG, 'Missing variant id');
      return;
    }
    if (gallery.dataset.activeVariantId === String(variantId) && slides(gallery).length) {
      return;
    }

    const data = parseGalleryData(gallery);
    const urls = urlsForVariant(data, variantId, colorValue);
    rebuildGallery(gallery, urls, variantId, colorValue);
  }

  function bindColorSwatches(gallery) {
    const root = document.querySelector('[data-custom-color-swatches]');
    if (!root || root.dataset.galleryBound === 'true') return;
    root.dataset.galleryBound = 'true';

    root.querySelectorAll('[data-color-swatch]').forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled || button.classList.contains('is-unavailable')) return;
        const colorValue = button.dataset.optionValue;
        const variantId = button.dataset.variantId;
        const optionPosition = button.dataset.optionPosition;
        const optionName = button.dataset.optionName;
        log('Swatch click', { colorValue, variantId, optionPosition, optionName });
        updateSwatchUI(colorValue, optionPosition, optionName);
        syncNativeRadio(colorValue, optionPosition, optionName);
        if (!isStaticGallery() && gallery) {
          loadGalleryForVariant(gallery, variantId, colorValue);
        }
      });
    });
  }

  function bindNativePicker(gallery) {
    const scope = document.querySelector('variant-selects') || document.querySelector('product-info');
    if (!scope || scope.dataset.galleryBound === 'true') return;
    scope.dataset.galleryBound = 'true';

    const onVariantId = (variantId, colorValue, optionPosition, optionName) => {
      if (colorValue) updateSwatchUI(colorValue, optionPosition, optionName);
      if (!isStaticGallery() && gallery && variantId) {
        loadGalleryForVariant(gallery, variantId, colorValue);
      }
    };

    scope.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) && !(target instanceof HTMLSelectElement)) return;
      const colorValue = target.value;
      const optionName = target.dataset?.optionName || '';
      const optionPosition = target.dataset?.optionPosition || '';
      const variantId =
        document.querySelector('input[name="id"]')?.value || new URLSearchParams(window.location.search).get('variant');
      window.requestAnimationFrame(() => {
        const id =
          document.querySelector('product-form input[name="id"]')?.value ||
          document.querySelector('input[name="id"]')?.value ||
          variantId;
        onVariantId(id, colorValue, optionPosition, optionName);
      });
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const id = event?.data?.variant?.id || document.querySelector('product-form input[name="id"]')?.value;
        const colorValue =
          event?.data?.variant?.option1 || document.querySelector('[data-selected-color-value]')?.textContent?.trim();
        onVariantId(id, colorValue);
      });
    }
  }

  function init() {
    const gallery = getGallery();

    hideNativeColorPicker();
    bindColorSwatches(gallery);
    bindNativePicker(gallery);

    if (!gallery) return;

    bindThumbnails(gallery);
    bindThumbNav(gallery);
    bindSwipe(gallery);

    gallery.dataset.activeVariantId = gallery.dataset.initialVariantId || '';
    if (!slides(gallery).length) {
      const data = parseGalleryData(gallery);
      const urls = urlsForVariant(data, gallery.dataset.initialVariantId, null);
      if (urls.length) rebuildGallery(gallery, urls, gallery.dataset.initialVariantId, null);
    }
    goTo(gallery, 0);
    window.addEventListener('resize', () => goTo(gallery, getSlider(gallery).index));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
